import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { addTag, setAddTag } from '../../action/handbook';
import cn from 'classnames';
import ErrorContainer from '../utils/ErrorContainer';

class AddTag extends Component {
    componentWillUnmount() {
        this.props.setAddTag({});
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Добавить отметку</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/tags')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidTag() {
        const { name, } = this.props.addForm;
        if (name) return true;
        
        return false;
    }

    setTag = (field) => (e) => {
        const data = {...this.props.addForm};
        data[field] = e.target.value;
        this.props.setAddTag(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.addTag(this.props.addForm).then(result => {
            if (result) {
                this.props.history.push('/handbook/tags');
            }
        });
    }    

    render() {
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-6">
                                    <Input
                                        label="Отметка"
                                        required={true}
                                        onChange={this.setTag('name')}
                                        value={this.props.addForm.name}
                                        placeholder="Название..."
                                    />                                 
                                </div>
                            </div>                            
                        </div>
                        <ErrorContainer field="addTag" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidTag() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loading })}>
                                    Добавить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    addForm: state.handbook.add,
    loading: state.loaders.addTag
});

const mapDispatchToProps = {
    setAddTag: (data) => setAddTag(data),
    addTag: (data) => addTag(data)
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTag);